import { 
  collection, 
  addDoc, 
  serverTimestamp,
  query,
  where,
  getDocs
} from 'firebase/firestore';
import { db } from './config';

export interface AffiliateApplication {
  fullName: string;
  email: string;
  country: string;
  socialMediaHandles: {
    instagram: string;
    tiktok: string;
    facebook: string;
    linkedin: string;
    x: string;
    youtube: string;
    other: string;
  };
  website: string;
  blog: string;
  promotionIntention: string;
  agreeToTerms: boolean;
  userId?: string | null; // Optional, if user is logged in
  status: 'pending' | 'approved' | 'rejected';
  createdAt: any; // Using any for serverTimestamp compatibility
}

export const submitAffiliateApplication = async (
  data: Omit<AffiliateApplication, 'status' | 'createdAt'>
): Promise<string> => {
  try {
    const docRef = await addDoc(collection(db, 'affiliate_applications'), {
      ...data,
      status: 'pending',
      createdAt: serverTimestamp(),
    });
    return docRef.id;
  } catch (error) {
    console.error('Error submitting affiliate application:', error);
    throw error;
  }
};

export const getUserAffiliateApplication = async (userId: string): Promise<AffiliateApplication | null> => {
  try {
    const q = query(
      collection(db, 'affiliate_applications'),
      where('userId', '==', userId),
      where('status', '==', 'pending')
    );
    const snapshot = await getDocs(q);
    if (!snapshot.empty) {
      return snapshot.docs[0].data() as AffiliateApplication;
    }
    return null;
  } catch (error) {
    console.error('Error fetching user affiliate application:', error);
    return null;
  }
};
